<template>
    <div class="editQuestCodes TQ_margin_16px">

        <!-- type -->
        <div class="TQ_align_initial">
            <div class="TQ_align_initial TQ_text_bold">
                {{ass_strings.oneWord_type[p_system_langCode_e]}}
            </div>

            <tq-dropdown
                class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle  TQ_box_shadow TQ_center TQ_width_200px TQ_bg_purple_lite2"
                :style-select="true">

                <div slot="select" class="TQ_padding_4px TQ_text_bold ">
                    {{m_formatHiddenCodeName_s(p_qb_metadata_c.qbm_quest_hiddenCodesMode_e)}}
                </div>

                <div slot="options"
                     v-for="hiddeCodeType_e in enum_hiddenCodesTypes"
                     :class="p_qb_metadata_c.qbm_quest_hiddenCodesMode_e === hiddeCodeType_e && 'TQ_text_bold TQ_bg_purple_lite2'"
                     @click="p_qb_metadata_c.qbm_quest_hiddenCodesMode_e = hiddeCodeType_e">
                    {{m_formatHiddenCodeName_s(hiddeCodeType_e)}}
                </div>
            </tq-dropdown>
        </div>


        <!-- hidden codes -->
        <div v-if="p_qb_metadata_c.qbm_quest_hiddenCodesMode_e > enum_hiddenCodesTypes.e_none_n">

            <!-- all free codes-->
            <div class="TQ_margin_16px">
                <div class="TQ_inline TQ_margin_4px TQ_text_16px TQ_borderRadius TQ_border TQ_padding_4px"
                     v-for="(clueCode_c,index_n) in p_cluesCodes_ac" :key="index_n" >

                    <tq-image class="TQ_verticalAlignMiddle TQ_bg_gray1 TQ_bg_circle TQ_width_16px TQ_padding_4px TQ_clickable TQ_bg_hover_shadow2"
                              :pb_src_r="ass_img_garbage_w" @click.native="p_cluesCodes_ac.splice(index_n,1)"/>

                    <span class="TQ_verticalAlignMiddle"> {{clueCode_c.qbcc_code_s}} </span>
                    <span class="TQ_verticalAlignMiddle TQ_text_12px" v-if="p_qb_metadata_c.qbm_quest_hiddenCodesMode_e === enum_hiddenCodesTypes.e_points_n"> ({{clueCode_c.qbcc_points_n}} {{ass_strings.oneWord_points[p_system_langCode_e]}})</span>

                </div>
            </div>

            <!-- add new free code-->
            <div>
                <div class="TQ_inline ">
                    <div class="TQ_align_initial TQ_text_14px TQ_textColor_gray1">
                        {{ass_strings.threeWords_newHintCode[p_system_langCode_e]}}
                    </div>
                    <input class="TQ_verticalAlignMiddle TQ_input TQ_align_initial TQ_padding_4px" v-model.lazy="newClueCode_s"
                           :placeholder="ass_strings.oneWord_text[p_system_langCode_e]"/>

                </div>

                <div class="TQ_inline TQ_margin_4px" v-if="p_qb_metadata_c.qbm_quest_hiddenCodesMode_e === enum_hiddenCodesTypes.e_points_n">
                    <div class="TQ_align_initial TQ_text_14px TQ_textColor_gray1">
                        {{ass_strings.oneWord_points[p_system_langCode_e]}}
                    </div>
                    <input class="TQ_verticalAlignMiddle TQ_width_72px TQ_input TQ_align_initial TQ_padding_4px" type="number" v-model.number="cluePoints_n"/>
                </div>

                <tq-image class="TQ_verticalAlignMiddle TQ_bg_gray1 TQ_width_20px TQ_bg_green TQ_padding_4px TQ_bg_hover_shadow2 TQ_clickable TQ_borderRadius"
                          :pb_src_r="ass_img_add_w" @click.native="m_addHint_f()"/>
            </div>

        </div>

    </div>
</template>

<script>
    import {ass_img_add_w, ass_img_garbage_w} from "../../../../assets/scripts/Ass_Files";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_hiddenCodesTypes, enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqImage from "@/components/basic/TqImage";
    import {FB_QuestBody_ClueCode, FB_QuestBody_Metadata} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqDropdown from "@/components/basic/TqDropdown";

    export default {
        name: "editOMBodyCodes",
        components: {TqDropdown, TqImage},
        props:{
            p_cluesCodes_ac:{
                require: true,
                type: Array
            },
            p_qb_metadata_c:{
                require: true,
                type: FB_QuestBody_Metadata
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
        },
        data(){
            return {
                newClueCode_s : "",
                cluePoints_n : 0,

                // imports
                enum_hiddenCodesTypes : enum_hiddenCodesTypes,

                ass_strings : ass_strings,
                ass_img_garbage_w : ass_img_garbage_w,
                ass_img_add_w : ass_img_add_w,
            }
        },

        methods:{
            m_addHint_f(){
                if(this.newClueCode_s !== "") {
                    this.p_cluesCodes_ac.push(new FB_QuestBody_ClueCode({qbcc_code_s: this.newClueCode_s, qbcc_points_n: this.cluePoints_n}))
                    this.newClueCode_s = ""
                }
            },
            m_formatHiddenCodeName_s(qbm_quest_hiddenCodesMode_e){
                switch (qbm_quest_hiddenCodesMode_e){
                    case enum_hiddenCodesTypes.e_none_n:
                        return ass_strings.oneWord_inactive[this.p_system_langCode_e]
                    case enum_hiddenCodesTypes.e_points_n:
                        return ass_strings.oneWord_points[this.p_system_langCode_e]
                    case enum_hiddenCodesTypes.e_clueCounter_n:
                        return ass_strings.twoWords_hintCounter[this.p_system_langCode_e]

                }
            }
        }
    }
</script>

<style scoped lang="scss">

  .editQuestCodes{
    text-align: center;

    .HintsCodes{
      /*width:100px;*/

    }

    .RevealsCodes{
      /*width: 10%;*/
      /*display: inline-block;*/
    }

  }




</style>
